"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationSummary = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../utils/classFunctions");
const Icon_1 = require("../../Icon");
const Info_1 = require("./Info");
require("./index.scss");
const className = 'reservation-summary';
const ReservationSummary = (props) => {
    const { agentInfo, bookingOptions, flights, isContentVisible = true, passengersTickets, seats, totalPriceText, modificators, } = props;
    const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement("input", { type: 'checkbox', className: `${className}__checkbox`, id: `${className}__checkbox` }),
        react_1.default.createElement("div", { className: `${className}__container` }, isContentVisible && (react_1.default.createElement("div", { className: `${className}__container-inner` },
            react_1.default.createElement("label", { htmlFor: `${className}__checkbox`, className: `${className}__trigger` },
                react_1.default.createElement("span", { className: `${className}__trigger-container` },
                    react_1.default.createElement("span", { className: `${className}__trigger-icon` },
                        react_1.default.createElement(Icon_1.Icon, { name: 'arrows-left' })),
                    react_1.default.createElement("span", { className: `${className}__trigger-text` },
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/Summary:TriggerText', defaultMessage: 'Summary' })),
                    react_1.default.createElement("span", { className: `${className}__trigger-icon` },
                        react_1.default.createElement(Icon_1.Icon, { name: 'arrows-left' })))),
            react_1.default.createElement(Info_1.ReservationSummaryInfo, { className: `${className}__content-wrapper`, flights: flights, passengersTickets: passengersTickets, bookingOptions: bookingOptions, seats: seats, agentInfo: agentInfo, totalPriceText: totalPriceText }))))));
};
exports.ReservationSummary = ReservationSummary;
//# sourceMappingURL=index.js.map